export default "__VITE_ASSET__Cuuv2Ax5__"